<template>
    <FilterPage class="px-4 pt-4" title="Équipe artistique" @reset="handleReset" v-on="$listeners">
        <div class="form-group mb-0">
            <label for="company">Nom</label>
            <input
                id="company"
                class="form-control"
                type="text"
                placeholder="Rechercher une équipe artistique..."
                autocomplete="off"
                :value="query"
                @input="handleInput"
            >
        </div>
        <template v-if="results || loading">
            <div class="border" style="max-height: 185px; overflow: auto">
                <template v-if="loading">
                    <div class="p-3 text-center">
                        <div class="spinner-border spinner-border-sm text-primary"></div>
                    </div>
                </template>
                <template v-else-if="!results.length">
                    <div class="p-3">
                        <em class="text-muted">Aucun résultat pour «{{ query }}»</em>
                    </div>
                </template>
                <template v-else>
                    <div class="list-group list-group-flush">
                        <template v-for="company in filteredResults">
                            <button class="list-group-item list-group-item-action" @click="handleSelected(company)" :key="company.id">
                                {{ company.name }}
                            </button>
                        </template>
                    </div>
                </template>
            </div>
        </template>
        <ul class="list-group my-4 font-weight-bold">
           <template v-for="company in companies">
               <li class="list-group-item" :key="company.id">
                   <div class="row">
                       <div class="col">
                           {{ company.name }}
                       </div>
                       <div class="col-auto">
                           <button class="close p-2" @click="handleRemoved(company)">
                               <svg class="d-block fill-current" style="width: .5em;height: .5em">
                                   <use xlink:href="#sprite-close"></use>
                               </svg>
                           </button>
                       </div>
                   </div>
               </li>
           </template>
        </ul>
    </FilterPage>
</template>
<script>
    import FilterPage from "../../../FilterPage";
    import { getCompanies } from "../../api";
    import debounce from 'lodash/debounce';

    export default {
        components: {
            FilterPage,
        },
        props: {
            // value: Object,
            companies: Array,
        },
        data() {
            return {
                query: '',
                results: null,
                loading: false,
            }
        },
        computed: {
            filteredResults() {
                return (this.results ?? []).filter(result =>
                    !(this.companies ?? []).some(company => company.id === result.id)
                );
            },
        },
        methods: {
            search(query) {
                this.loading = true;
                getCompanies({ query })
                    .then(results => {
                        this.results = results;
                    })
                    .finally(() => {
                        this.loading = false;
                    })
            },
            handleInput(e) {
                this.query = e.target.value;
                if(this.query.length < 3) {
                    this.results = null;
                    return;
                }
                this.search(this.query);
            },
            handleSelected(company) {
                this.$emit('companies-change', [
                    ...(this.companies ?? []),
                    company,
                ]);
            },
            handleRemoved(company) {
                this.$emit('companies-change',
                    this.companies.filter(c => c.id !== company.id)
                );
            },
            handleReset() {
                this.$emit('companies-change', []);
            },
        },
        created() {
            this.search = debounce(this.search, 300);
        }
    }
</script>